<template>
    <div style="padding: 10px;" class="container">
        <div class="loader" v-if="loading"></div>
            <div href="#" class="pages photo_book_page_list_item">
                <div class="loader" v-if="loading"></div>
                <div class="tag">
                    {{ photo_book_image.pos }}
                </div>
                <b-img-lazy :src="imageSrc" width="200px" alt=""></b-img-lazy>
            </div>
        <!-- 
        spread_type: {{ spreadType }} 
        <br>
        spread_id: {{ spreadId }} 
        <br>
        image_id {{ image }}
        -->
    </div>
</template>

<script>
import Comment from '@/components/Feed/Comment';
import { mapGetters } from "vuex";
import { Modal, BaseAlert } from '@/components'
import photo_book_page from '../../../store/photo_book_page';
import { image } from 'd3';

export default {
    name: "photo-book-interior-spread",
    components: {
        Modal,
        BaseAlert,
    },
    props: {
        image: '',
        spreadId: '',
        spreadType:'',
        photo_book_image_id: '',
        photo_book_page_id: '',

    },
    data() {
        return {
            loading: false,
            photo_book_image: '',
            imageSrc: "img/custom/portal-portrait-4.png",
        };
    },
    methods: {
        retrievePhotoBookImage() {
            this.loading = true;
            let query = {};
            this.$api.getPhotoBookImage(this.currentPhotoBook.id, this.image)
                .then((response) => {
                    this.photo_book_image = response.data;
                    console.log(this.photo_book_image);
                })
                .catch((e) => {
                    console.log(e);
                }).finally(() => {
                    this.loading = false;
                    this.imageSrc= process.env.VUE_APP_API_HOST + this.photo_book_image.image.medium.url;
                    return process.env.VUE_APP_API_HOST + this.photo_book_image.image.medium.url;
                });
        },
    },
    watch: {
        image(newValue, oldValue) {
            console.log('queryParameter image changed from: ' + oldValue + ' -> ' + newValue);
            this.spreadId = this.image;
            this.loading = true;
            setTimeout(() => this.retrievePhotoBookImage(), 8000);
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
        }),

    },
    mounted() {
        if(Number(this.image) > 0){
            this.retrievePhotoBookImage();
        }
    },
};
</script>
<style scoped>
    .container {
       /*border: 1px solid #DDDDDD;*/
       width: 200px;
       position: relative;
    }
    .tag {
       float: left;
       position: absolute;
       left: 10px;
       top: 10px;
       z-index: 1000;
       background-color: #92AD40;
       padding: 5px;
       color: #FFFFFF;
       font-weight: bold;
    }
    </style>